import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

// Types derive from the backend OpenAPI contract (generated schema.d.ts).
export type TemplateEngine = Schemas['TemplateEngine'];
export type TemplateStatus = Schemas['TemplateStatus'];
export type TemplateMetadata = Schemas['TemplateMetadata'];
export type TemplateSummary = Schemas['TemplateSummary'];
export type RenderedTemplate = Schemas['RenderedTemplate'];
export type TemplateVersionSummary = Schemas['TemplateVersionSummary'];
export type UpsertTemplateBody = Schemas['UpsertRequest'];

export const templates = {
  list: (includeArchived = false) =>
    request<TemplateMetadata[]>(`/v1/templates${includeArchived ? '?include_archived=true' : ''}`),

  get: (id: string) => request<TemplateSummary>(`/v1/templates/${id}`),

  upsert: (body: UpsertTemplateBody) =>
    request<TemplateSummary>('/v1/templates', { method: 'PUT', body }),

  preview: (id: string, data: Record<string, unknown>) =>
    request<RenderedTemplate>(`/v1/templates/${id}/preview`, { method: 'POST', body: { data } }),

  publish: (id: string) =>
    request<TemplateSummary>(`/v1/templates/${id}/publish`, { method: 'POST' }),

  versions: (id: string) =>
    request<TemplateVersionSummary[]>(`/v1/templates/${id}/versions`),
};
